module.exports = __webpack_public_path__ + "img/9feb05e.png";